<template>
  <div class="bg">
    <div class="headerText">
      今日在场人数：
      <span>
        {{ personnelNum }}
      </span>
      人
    </div>
    <div class="content">
      <el-card
        v-for="(item, index) in personnelInfo"
        :key="index"
      >
        <el-row>
          <el-col :span="8">
            <div class="img">
              <img
                :src="item.data1"
                alt=""
              >
            </div>
          </el-col>
          <el-col :span="16">
            <p>
              <span>姓名：{{ item.data2 }}</span>
            </p>
            <p>
              <span>班组：{{ item.data3 }}</span>
            </p>
            <p>
              <span> 时间：{{ item.data4 }} </span>
            </p>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      personnelNum: 50,
      // 人员信息
      personnelInfo: [
        {
          data1: require("@/assets/login/bg.jpg"),
          data2: "王增",
          data3: "综合部",
          data4: "2021-01-04 15:20:12",
        },
        {
          data1: require("@/assets/login/bg.jpg"),
          data2: "陈小川",
          data3: "销售部",
          data4: "2021-01-04 15:12:02",
        },
        {
          data1: require("@/assets/login/bg.jpg"),
          data2: "陆峰",
          data3: "综合部",
          data4: "2021-01-04 12:20:52",
        },
        {
          data1: require("@/assets/login/bg.jpg"),
          data2: "陆峰",
          data3: "综合部",
          data4: "2021-01-04 12:20:52",
        },
        {
          data1: require("@/assets/login/bg.jpg"),
          data2: "陆峰",
          data3: "综合部",
          data4: "2021-01-04 12:20:52",
        },
        {
          data1: require("@/assets/login/bg.jpg"),
          data2: "陆峰",
          data3: "综合部",
          data4: "2021-01-04 12:20:52",
        },
      ],
    };
  },
};
</script>
<style lang="less" scoped>
.bg { margin-bottom: 40px;
  padding: 10px;
  min-height: 100vh;
  margin-bottom: 40px;
  background-color: #f0f0f0;
}
.headerText {
  font-size: 16px;
  margin-bottom: 10px;
  span {
    font-size: 20px;
    font-weight: bold;
  }
}
.content {
  font-size: 14px;
  .el-card {
    margin-bottom: 10px;
  }
  .img {
    img {
      width: 80px;
      height: 80px;
      border-radius: 4px;
    }
  }
  p {
    margin-bottom: 8px;
  }
}
</style>
